
import u from "umbrellajs"
import {CleaveOptions} from "cleave.js/options"

const INIT_DONE_CLASS = "js-cleave-js--init-done"

const init = (selector: string = ".js-cleave-js", options: CleaveOptions = {}) => {
  import(
    "cleave.js"
  )
  .then(({default: Cleave}) => {
    u(selector).each((el) => {
      if (el.classList.contains(INIT_DONE_CLASS)) { return }

      el.classList.add(INIT_DONE_CLASS)

      const options_all = Object.assign(options, {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
      })

      const cleave = new Cleave(el as HTMLElement, options_all)
    })
  })
}

export default {init}
